import { ChakraFlex } from '@equip.health/ui';

import { PatientTabProps } from '~/lib/constants/patients.constants';
import SMT from '~/components/maud/patients/profile/smt';
import { useGetSMTPermissionsQuery } from '~/store/services/SMT';

const PatientSMTTab = ({ patient }: PatientTabProps) => {
  const { userId: patientId } = patient;
  const { data: smtPermissions } = useGetSMTPermissionsQuery(patientId);
  const isSMTEnabledForPatient = smtPermissions?.smtEnabled ?? false;

  return (
    <ChakraFlex
      flexDirection="column"
      gap="24px"
      marginBottom="24px"
      marginTop="12px"
    >
      <SMT
        isSMTEnabledForPatient={isSMTEnabledForPatient}
        patientId={patientId}
      />
    </ChakraFlex>
  );
};

export default PatientSMTTab;
